import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Row = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    paddingTop: theme.spacing.small,
    borderTop: `1px dashed ${theme.colors[theme.colorMode].border_Tertiary}`,
}));

export const Cell = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
}));

export const SubText = styled(Text)(({ theme }) => ({
    marginRight: theme.spacing.medium,
}));
